export default __webpack_public_path__ + "static/media/home-business-tab-img03.eb0a54e9.jpg";